import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PieChartComponent from "./PieChart";
import LinearProgressChart from "./LinearProgressChart ";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiUpload } from "react-icons/fi";
const BenefitsAccumulator = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [benefitType, setBenefitType] = useState("");
  const [benefitData, setBenefitData] = useState([]);
  const [accumulatorText, setAccumulatorText] = useState("");
  const [note, setNote] = useState("");
  const [emailSending, setEmailSending] = useState(false);
  const navigate = useNavigate();
  const contract = useSelector((state) => state.userData.userData.ContractIdentified);
  const memberid = useSelector((state) => state.userData.userData.MemberID);
  const token = localStorage.getItem("AccessToken");
  const emailid = useSelector((state) => state.userData.userData.EmailID);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [unlimited, setUnlimited] = useState(false);
  const pieChartRefs = useRef([]);

  // Send accumulator summary to email
  const handlEmailSummary = async () => {
    try {
      setEmailSending(true);
      const params = { EmailID: emailid, DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal" };
      const response = await axios.post(
        Endpoints.SendAccumulatorDetails,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { Result } = response?.data || {};
      if (Result === 1) {
        toast.success("Email sent successfully.");
      } else {
        toast.error("Failed to send email summary.");
      }
    } catch (error) {
      console.error("Error sending email summary:", error);
      toast.error("An error occurred while sending the email summary.");
    } finally {
      setEmailSending(false);
    }
  };

  // Trigger handlesharereport on the last PieChartComponent instance
  const handleShareReportClick = () => {
    try {
      const lastIndex = benefitData.length - 1;
      const pieRef = pieChartRefs.current[lastIndex];
      if (pieRef && typeof pieRef.handleShareReport === "function") {
        pieRef.handleShareReport();
      } else {
        toast.error("Unable to share report.");
      }
    } catch (e) {
      toast.error("An error occurred while sharing the report.");
      console.error(e);
    }
  };

  useEffect(() => {
    setLoading(true); // Ensure loader shows on every API call
    const fetchData = async () => {
      const params = { MemberID: memberid, Contract: contract,DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        EmailID:emailid };

      try {
        const response = await axios.post(
          Endpoints.LoadAccumulatorBySpeciality,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          console.log(response.data);
          setBenefitType(response.data.BenefitType);
          setBenefitData(response.data.BenefitOutput || []);
          const benefitOutput = response.data.BenefitOutput || [];
          setUnlimited(benefitOutput[0].Category === "Cycle Limit" && benefitOutput[0].BenefitLimit >= 99);
          setAccumulatorText(response.data.AccumulatorText) // Store BenefitOutput
          setNote(response.data.Note);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [contract, memberid, token]);

  // Helper function to parse dollar values
  const parseDollarValue = (value) => {
    if (typeof value === "string") {
      return parseFloat(value.replace(/[^0-9.-]+/g, "")) || 0;
    }
    return 0;
  };
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

 const handleClickBack=()=>
 {
    navigate(-1)
 }
  return (
    <>      
      <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn me-1" onClick={handleClickBack}>
              <span>
                  <i className="bi bi-chevron-left"></i> {t('back')}
              </span>
          </button>
          <h2 className="page-heading">{t('benefitsaccumalator')}</h2>
      </div>

      <div className="col-md-12 mt-1">
        {benefitType === "Cycle Limit"  ?
         (
         benefitData.length > 0 ?(
          <>
           <div className="row d-flex">
            {benefitData.map((item, index) => {
              const length = benefitData.length;
              const total = parseInt(item.BenefitLimit.replace(/[$,\s]/g, ""), 10) || 0;
              const remaining = parseInt(item.BenefitRemaining.replace(/[$,\s]/g, ""), 10) || 0;
              const used = total - remaining;
              const isLastItem = index === benefitData.length - 1; // only last item true
               debugger;
             // Only render this div if the condition for Cycle Limit is met
              if (item.Category === "Cycle Limit") {
                return (
                  <>
                  {!unlimited && 
                  <div key={index} className="col-md-6 col-sm-12">
                    <PieChartComponent
                      ref={(el) => (pieChartRefs.current[index] = el)}
                      key={index}
                      used={used}
                      remaining={remaining}
                      total={total}
                      accumulatorType={accumulatorText}
                      category={item.Category}
                      islastitem={isLastItem}
                    />
                  </div>}
                  {length == 1 && (
                    <div key={index} className="col-md-6 col-sm-12">
                    {/* Benefits Information */}
                    {accumulatorText !== "" && (
                      <div className="accumulator-text">
                        {t("accumulatortype")} <span>{accumulatorText}</span>
                      </div>
                    )}

                    <div className="d-flex flex-column gap-3 mb-4">
                      {!unlimited && (
                        <div className="col-md-5 total-benefits-label">
                          <strong>{t("totalbenefit")}</strong> <span>{benefitData[0].BenefitLimit}</span>
                        </div>
                      )}
                      <div className="col-md-5 used-benefits-label">
                        <strong> {unlimited ? "CYCLES" : ""} {t("used")}</strong> <span>{benefitData[0].BenefitLimit - benefitData[0].BenefitRemaining}</span>
                      </div>
                      {!unlimited && (
                        <div className="col-md-5 remaining-benefits-label">
                          <strong>{t("remaining")}</strong> <span>{benefitData[0].BenefitRemaining}</span>
                        </div>
                      )}
                    </div>
                      </div>
                  )    
                  }
                  </>
                );
              }


              // Render the div for LinearProgressChart when the condition is not met
              if (item.Category !== "Cycle Limit") {
                const currencyMatch = item.BenefitLimit.match(/[^\d.,\s]+/);
                const currencySymbol = currencyMatch ? currencyMatch[0] : "";
                return (
                  <div key={index} className="col-md-6 col-sm-12">
                    {/* Benefits Information */}
                    {accumulatorText !== "" && (
                      <div className="accumulator-text">
                        {t("accumulatortype")} <span>{accumulatorText}</span>
                      </div>
                    )}

                    {benefitData[0].Category == "Cycle Limit" && <div className="d-flex flex-column gap-3 mb-4">
                      {!unlimited && (
                        <div className="col-md-5 total-benefits-label">
                          <strong>{t("totalbenefit")}</strong> <span>{benefitData[0].BenefitLimit}</span>
                        </div>
                      )}
                      <div className="col-md-5 used-benefits-label">
                        <strong> {unlimited ? "CYCLES" : ""} {t("used")}</strong> <span>{benefitData[0].BenefitLimit - benefitData[0].BenefitRemaining}</span>
                      </div>
                      {!unlimited && (
                        <div className="col-md-5 remaining-benefits-label">
                          <strong>{t("remaining")}</strong> <span>{benefitData[0].BenefitRemaining}</span>
                        </div>
                      )}
                    </div>}

                    <LinearProgressChart
                      key={`lp-${index}`}
                      category={item.Category} // e.g., "Fertility/RX"
                      used={used}
                      remaining={`${currencySymbol} ${remaining}`}
                      total={`${currencySymbol} ${total}`}
                      accumulatorType={accumulatorText}
                      currencySymbol={currencySymbol}
                    />
                  </div>
                );
              }
            })}

            {/* Bottom containers: non-unlimited shows button; unlimited shows only note under linear chart */}
            {benefitType === "Cycle Limit" && !unlimited && (
              <div className="order-2 w-100 mt-4 d-flex flex-wrap justify-content-start mb-5 mb-md-0">
                {accumulatorText !== "" && (
                      <div className="accumulator-text">
                        {t("accumulatortype")} <span>{accumulatorText}</span>
                      </div>
                    )}
                { note && (<p>{note}</p>)}
                <p className="me-3">
                  This is an estimate of the amount remaining in your benefit. The estimated amount may not reflect claims not yet submitted to WIN or claims not yet processed by WIN.
                </p>
                <button
                  className="win-btn-primary mobile-view"
                  onClick={handleShareReportClick}
                  disabled={loading}
                >
                  <FiUpload style={{ marginRight: "8px" }} /> {t("sharepoint")}
                </button>
              </div>
            )}
            {benefitType === "Cycle Limit" && unlimited && (
              <div className="order-2 w-100 mt-4 mb-5 mb-md-0">
                {accumulatorText !== "" && (
                      <div className="accumulator-text">
                        {t("accumulatortype")} <span>{accumulatorText}</span>
                      </div>
                    )}
                { note && (<p>{note}</p>)}
                <p className="note-black-16">
                  This is an estimate of the amount remaining in your benefit. The estimated amount may not reflect claims not yet submitted to WIN or claims not yet processed by WIN.
                </p>
                <button
                  className="win-btn-primary mobile-view"
                  onClick={handleShareReportClick}
                  disabled={loading}
                >
                  <FiUpload style={{ marginRight: "8px" }} /> {t("sharepoint")}
                </button>
              </div>
            )}
        </div>
          </>
         ):(
         <div className="no-data-message">No Cycles available.</div>)
      ):(
        <>
        
        </>
      )
      }

      {benefitType === "Dollar Limit" ?
        (
          benefitData.length > 0 ? (
              <div className="col-md-12 col-sm-12">
                {accumulatorText && (
                  <div className="accumulator-text mb-3">
                    <span className="page-heading-secondary-gray">{accumulatorText}</span>
                  </div>
                )}
                <div className="linear-progress-bar">
                  {benefitData.map((item, index) => {
                    // Extract currency symbol from BenefitLimit (e.g., "$" or other)
                    const currencyMatch = item.BenefitLimit.match(/[^\d.,\s]+/);
                    const currencySymbol = currencyMatch ? currencyMatch[0] : "";
                    const total = parseDollarValue(item.BenefitLimit);
                    const remaining = parseDollarValue(item.BenefitRemaining);
                    const used = total - remaining;

                    return (
                      <LinearProgressChart
                        key={index}
                        category={item.Category} // e.g., "Fertility/RX"
                        used={used}
                        remaining={item.BenefitRemaining}
                        total={item.BenefitLimit}
                        accumulatorType={accumulatorText}
                        currencySymbol={currencySymbol}
                      />
                    );
                  })}
                </div><br />
                { note && (<p>{note}</p>)}
                <p>Request a summary of your benefit utilization with a single tap.</p>
                <div className="mt-3 d-flex">
                  <button
                    className="win-btn-primary"
                    onClick={handlEmailSummary}
                    disabled={emailSending}
                  >
                    {emailSending ? t("sending") : t("emailmesummary")}
                  </button>
                  {emailSending && (
                    <div className="loading-container ms-2">
                      <div className="loading small"></div>
                    </div>
                  )}
                </div>
              </div>
          ) : (
            <>
              <div className="no-data-message">
                No Cycles available.
              </div>
            </>
          )
        ) :( 
      <>
      </>
      )
    }
  
      </div>
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

export default BenefitsAccumulator;
